// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// Toast
require('jquery-toast-plugin/src/jquery.toast');

// Modules
window.vgp = require('../../../modules/index.esm');